<script lang="ts">
    import imgFire from '@src/assets/img/fire.webp';
</script>

<span
    class="absolute right-0 top-0 inline-flex items-center rounded-bl-full rounded-tr-xl bg-gradient-to-r from-[#E65C00] to-[#F9D423] px-2 py-0.5 text-xxs font-bold uppercase text-white s-phone:px-4 s-phone:text-xs desktop:text-sm"
>
    Popular
</span>
<img src={imgFire} class="h-6 w-6" alt="fire img" />
